import { LANGUAGE_NAME, LOCALES } from '@shh/shared';
import { locale } from '../lib/locale';

/**
 * Settings → Sprache (1.19): one place for the language – this device or the whole family
 * (Mike, 14.10.: „überhaupt nicht intuitiv, dass man Spracheinstellungen an zwei Stellen hat“).
 * German is the master; language names come from LANGUAGE_NAME (always in their own language).
 */
export const LANGUAGE_TEXT = {
  de: {
    title: 'Sprache',
    hint: 'Deutsch oder Englisch – für dieses Gerät oder die ganze Familie',
    language: 'Sprache',
    forWhom: 'Für wen?',
    device: 'Nur dieses Gerät',
    deviceHint: 'Die App auf diesem Handy oder Tablet.',
    family: 'Die ganze Familie',
    familyHint:
      'Auch Erinnerungen, E-Mails, Vorlagen und KI-Vorschläge für alle. Andere Geräte behalten ihre eigene Anzeige-Sprache.',
    apply: 'Übernehmen',
    current: (device: string, family: string) =>
      `Gerade: Dieses Gerät ${device} · Familie ${family}`,
    currentDevice: (device: string) => `Gerade: ${device}`,
    /** language names inside a sentence – in the language of the sentence */
    names: { de: 'Deutsch', en: 'Englisch' },
    saved: 'Gespeichert',
    failed: 'Konnte nicht gespeichert werden. Bitte später nochmal versuchen.',
  },
  en: {
    title: 'Language',
    hint: 'German or English – for this device or the whole family',
    language: 'Language',
    forWhom: 'For whom?',
    device: 'Only this device',
    deviceHint: 'The app on this phone or tablet.',
    family: 'The whole family',
    familyHint:
      'Also reminders, emails, templates and AI suggestions for everyone. Other devices keep their own display language.',
    apply: 'Apply',
    current: (device: string, family: string) =>
      `Currently: this device ${device} · family ${family}`,
    currentDevice: (device: string) => `Currently: ${device}`,
    names: { de: 'German', en: 'English' },
    saved: 'Saved',
    failed: 'Couldn’t be saved. Please try again later.',
  },
} as const;

export const languageText = LANGUAGE_TEXT[locale];

/** Every language in its own name. */
export const languageChoices = LOCALES.map((l) => ({ value: l, label: LANGUAGE_NAME[l] }));
